import React from 'react';
import { Header, Button } from 'semantic-ui-react';
import './PostSubmissionMessage.css';
var defaultProps = {
  buttonText: 'Submit Another Response'
};
export default function PostSubmissionMessage(_ref) {
  var message = _ref.message,
    buttonText = _ref.buttonText,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("div", {
    className: "post-form-submission"
  }, /*#__PURE__*/React.createElement(Header, {
    as: "h4",
    className: "submission-header"
  }, message), /*#__PURE__*/React.createElement(Button, {
    primary: true,
    onClick: onClick
  }, buttonText));
}
PostSubmissionMessage.defaultProps = defaultProps;